<div app-sidenav>
  <app-accordion class="mb-5 mt-5 grid w-full">
    <app-accordion-item headerClass="border">
      <div app-accordion-header class="whitespace-normal!">
        <div class="py-5">
          <h1 class="text-xl">{{ data.courseResponse.titulo }}</h1>
          <span class="text-md text-theme-400">{{ data.courseResponse.curso.titulo }}</span>
          @if (!data.courseResponse.porcentagem) {
            <p class="text-md text-theme-400" translate>trilhas.estudio.pre-visualizacao</p>
          }
        </div>
        @if (!!data.courseResponse.porcentagem) {
          <div
            class="my-5 mr-10 h-1.5 rounded-full bg-gray-200"
            app-tooltip
            tooltip="{{ data.courseResponse.porcentagem }}%"
          >
            <div
              class="h-1.5 rounded-full"
              [style.width.%]="data.courseResponse.porcentagem"
              [ngClass]="{
                'bg-[#f59e0b]': data.courseResponse.porcentagem <= 30,
                'bg-blue-500': data.courseResponse.porcentagem >= 31 && data.courseResponse.porcentagem <= 90,
                'bg-green-500': data.courseResponse.porcentagem >= 91,
              }"
            ></div>
          </div>
        }
      </div>
      <div app-accordion-content class="rounded-xl px-2 pb-2">
        <div class="flex w-full flex-col items-start justify-center gap-5">
          <div class="w-full rounded-xl bg-white p-4 shadow">
            <img
              class="rounded-xl"
              [src]="data.courseResponse.thumbnail ?? '../../../../../assets/images/default.png'"
              alt="Imagem do Curso"
            />
          </div>

          <div class="flex flex-col justify-between px-2">
            @if (data.courseResponse.carga_horaria) {
              <div translate class="flex items-center justify-start gap-2">
                <span translate class="font-semibold text-theme-400">trilhas.carga-horaria</span>
                <div class="flex items-center justify-start gap-2">
                  <span translate>{{ data.courseResponse.carga_horaria ?? '-' }} </span>
                  <span translate>trilhas.estudio.trilha.horas </span>
                </div>
              </div>
            }
            @if (!!data.courseResponse.evento?.data_inicio) {
              <div class="flex flex-col justify-start">
                <span translate class="font-semibold text-theme-400">trilhas.inicio</span>
                <span>{{ data.courseResponse.evento.data_inicio | dateTranslate }}</span>
              </div>
            }
            @if (!!data.courseResponse.evento?.data_fim) {
              <div class="flex flex-col justify-start">
                <span translate class="font-semibold text-theme-400">trilhas.finaliza</span>
                <span>{{ data.courseResponse.evento.data_fim | dateTranslate }}</span>
              </div>
            }
          </div>
          @if (data.courseResponse.descricao) {
            <div class="flex w-full flex-col items-start justify-center px-2">
              <p translate class="font-semibold text-theme-400">trilhas.estudio.vitrine.descricao</p>
              <p
                class="max-h-[20rem] w-full overflow-y-auto rounded-xl border bg-white p-4"
                [innerHTML]="data.courseResponse.descricao"
              ></p>
            </div>
          }
        </div>
      </div>
    </app-accordion-item>
  </app-accordion>

  <app-accordion>
    @for (session of data.courseResponse.sessoes; track session.slug) {
      <app-accordion-item
        #item
        [expanded]="session.slug === selectedSessionSlug"
        headerClass="border {{ item.expanded ? '!border-3 shadow-black/40' : '' }}"
      >
        <div app-accordion-header class="whitespace-normal!">
          <span class="text-md font-semibold">{{ session.titulo }}</span>
        </div>

        <div app-accordion-content class="px-3">
          @let currentElement = selectedElement$ | async;
          @if (currentElement) {
            @for (element of session.elementos; track element.slug) {
              <div
                class="w-12/12 mb-2 flex cursor-pointer items-center justify-between rounded-xl border p-3 shadow-md hover:bg-gray-200"
                (click)="onChangeElement(session, element)"
                [ngClass]="{ 'bg-gray-200': element.slug === currentElement.slug }"
              >
                <div class="w-2/12">
                  <svg-icon
                    class="flex h-8 w-8 justify-center text-theme-700 group-hover:text-theme-contrast"
                    [src]="'assets/icons/' + typeIcon(element.tipo)"
                  ></svg-icon>
                </div>
                <div class="flex w-9/12 flex-col items-start justify-start">
                  <p class="text-md">{{ element.titulo }}</p>
                </div>
                <div class="mr-2 flex w-1/12 justify-center p-2">
                  @if (element.finalizado) {
                    <svg-icon
                      class="flex h-5 w-5 rounded-full bg-green-500 p-1 text-white"
                      src="assets/icons/icon-check.svg"
                    ></svg-icon>
                  }
                </div>
              </div>
            }
          }
        </div>
      </app-accordion-item>
    }
  </app-accordion>
</div>
